import { render, staticRenderFns } from "./EditCoffeeVariety.vue?vue&type=template&id=30b06e60"
import script from "./EditCoffeeVariety.vue?vue&type=script&lang=js"
export * from "./EditCoffeeVariety.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports